import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { P2pPage } from './p2p';

@NgModule({
  declarations: [
    P2pPage,
  ],
  imports: [
    IonicPageModule.forChild(P2pPage),
  ],
})
export class P2pPageModule {}



// WEBPACK FOOTER //
// ./src/pages/p2p/p2p.module.ts